export default __webpack_public_path__ + "5c59dcfb11962b3c943c45d53ed50bea.svg";